module.exports = __webpack_public_path__ + "img/ANKR.0ebb52d0.svg";